// extracted by mini-css-extract-plugin
export default {"root":"profile_attribute-modal___root___d3fd339d"};